import { motion } from "framer-motion";
import { PARTNERS } from "@/data/content";
import { fadeUpSmall, staggered } from "@/lib/motion";

export const Partners = () => (
  <section data-testid="partners-section" className="bg-white py-14 sm:py-20">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <h2 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl text-ink">We Proudly Support</h2>
      <div className="mt-8 grid grid-cols-3 items-center gap-8 sm:grid-cols-5">
        {PARTNERS.map((p, i) => (
          <motion.a
            key={p.name}
            data-testid={`partner-logo-${i + 1}`}
            href={p.href}
            target="_blank"
            rel="noopener noreferrer"
            title={p.name}
            {...staggered(fadeUpSmall, i, 0.05)}
            className="flex h-20 items-center justify-center"
          >
            <img
              src={p.logo}
              alt={`${p.name} logo`}
              className="max-h-20 w-auto max-w-full object-contain"
            />
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
